import gql from 'graphql-tag';

export const ListZipCodeQuery = gql`
  query ListZipCodeQuery {
    zipCodes {
      id
      name
      county
      city
    }
  }
`;

export const ListZipCodeDetailedQuery = gql`
  query ListZipCodeQuery {
    zipCodes {
      id
      name
      county
      city
      latitude
      longitude
    }
  }
`;
